export default __webpack_public_path__ + "static/media/project2-DJI_0439.56b49859.jpg";